import {PERMISSIONS, withPermission} from 'rbac'

export const useSettingsPermissions = () => {
  const canIAccessSettingsGeneral = withPermission([
    PERMISSIONS.GENERAL_SETTINGS.READ,
  ])

  const canIAccessSettingsBlockPage = withPermission([
    PERMISSIONS.BLOCK_PAGES.READ,
  ])

  const canIAccessSettingsEndpoints = withPermission([
    PERMISSIONS.ENDPOINT_CONFIGURATION.READ,
  ])

  const canIAccessSettingsUsers = withPermission([
    PERMISSIONS.USER_MANAGEMENT.READ,
  ])

  const canIAccessSettingsAuditLogs = withPermission([
    PERMISSIONS.AUDIT_LOG.READ,
  ])

  const canIAccessSettingsSEIM = withPermission([
    PERMISSIONS.ADD_S3_BUCKET_LOCATION.WRITE,
  ])

  const canIAccessSettingsAPI = withPermission([PERMISSIONS.API_KEYS.READ])

  const canIAccessSettingsBilling = withPermission([
    PERMISSIONS.BILLING_DETAILS.READ,
  ])

  return {
    canIAccessSettingsGeneral,
    canIAccessSettingsBlockPage,
    canIAccessSettingsEndpoints,
    canIAccessSettingsUsers,
    canIAccessSettingsAuditLogs,
    canIAccessSettingsSEIM,
    canIAccessSettingsAPI,
    canIAccessSettingsBilling,
  }
}

export const useSettingsDefaultPage = () => {
  const {
    canIAccessSettingsGeneral,
    canIAccessSettingsBlockPage,
    canIAccessSettingsEndpoints,
    canIAccessSettingsUsers,
    canIAccessSettingsAuditLogs,
    canIAccessSettingsSEIM,
    canIAccessSettingsAPI,
    canIAccessSettingsBilling,
  } = useSettingsPermissions()

  const permissionsOrder = [
    {check: canIAccessSettingsGeneral, route: '/settings/general'},
    {check: canIAccessSettingsBlockPage, route: '/settings/block-pages'},
    {check: canIAccessSettingsEndpoints, route: '/settings/endpoints'},
    {check: canIAccessSettingsUsers, route: '/settings/users'},
    {check: canIAccessSettingsAuditLogs, route: '/settings/audit-log'},
    {check: canIAccessSettingsSEIM, route: '/settings/seim'},
    {check: canIAccessSettingsAPI, route: '/settings/api'},
    {check: canIAccessSettingsBilling, route: '/settings/billing'},
  ]

  const defaultPage = permissionsOrder.find(({check}) => check)

  return defaultPage ? defaultPage.route : '/settings/general'
}
